<div class="card flex justify-center">
  <p-dialog
    header="New version is available"
    [modal]="true"
    [closable]="false"
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    [style]="{ width: '50rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <p class="mb-4">A new version is available for update.</p>

    <div class="flex flex-row-reverse justify-start gap-4">
      <p-button label="Use new version" (click)="confirm()" />
      <p-button label="Later" severity="secondary" (click)="close()" />
    </div>
  </p-dialog>
</div>
